function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { rem } from 'polished';
import React from 'react';
import Box from '../Box';
const PaperstacIcon = _ref => {
  let {
    size,
    bg,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 119 119",
    width: rem(size),
    height: rem(size),
    fill: bg,
    verticalAlign: "middle"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M118.6 57.1C104 66.8 89.9 76.2 75.7 85.7 52.1 73.1 27.4 70.8.7 77.4c22.1-22.1 89-33.4 117.9-20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.4 34.2c13-8.7 25.3-17 37.9-25.4 24.5 20.7 51.1 22.4 79.9 7.4-5.4 9.6-26.5 22.2-39.3 26.2-27 8.2-52.6 4.4-78.5-8.2zm100.9-7.4C77.1 33 56.5 27.7 38 12.9 27.8 19.8 17.8 26.5 7.6 33.4c28.5 14.5 67.8 13.5 93.7-6.6zM75.8 97.9C54.1 84.2 31 78.6 4.6 84.9c5.2-4.9 10.7-4.9 16-5.3 17.9-1.5 34.6 2.9 50.5 11 1.5.8 2.9 1.5 4.7 2.4 11.8-7.9 23.6-15.8 35.6-23.6 1.7-1.1 4.2-1.2 6.3-1.7.2.6.5 1.2.7 1.7-14.2 9.5-28.3 19-42.6 28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3 90.4c23.3-4.9 43.7 3 63.5 15C87.5 97.5 99.2 89.6 111 82c1.8-1.2 4.4-1.2 6.6-1.8l.6 1.8c-14 9.4-28.1 18.7-42.4 28.3-19.2-13.1-40.1-20.6-63.5-19.9z"
  }));
};
PaperstacIcon.defaultProps = {
  size: 16,
  bg: 'currentColor'
};
export default PaperstacIcon;